import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { FileUploadResult } from '../../dto/file-upload-result';
import { map, retry } from 'rxjs/operators';
import { FileMetadata } from '../../dto/file-metadata';
import { Observable } from 'rxjs';
import { API_SERVER } from '../../tokens';

@Injectable({
  providedIn: 'root'
})
export class FilesService {
  constructor(
    private http: HttpClient,
    @Inject(API_SERVER) private apiServer: string
  ) {}

  uploadFile(
    data: FormData
  ): Observable<FileUploadResult[] | { progress: number } | null> {
    return this.http
      .put(`${this.apiServer}api/Files`, data, {
        reportProgress: true,
        observe: 'events'
      })
      .pipe(
        map((event: any) => {
          const e = event as HttpEvent<FileUploadResult[]>;
          if (e) {
            switch (e.type) {
              case HttpEventType.UploadProgress:
                if (e.total) {
                  const progress = Math.round((100 * e.loaded) / e.total);
                  return { progress };
                } else {
                  return { progress: 0 };
                }

              case HttpEventType.Response:
                return e.body;
              default:
                // console.log(`Unhandled event: ${e.type}`);
                return null;
            }
          } else {
            return null;
          }
        })
      );
  }

  getFileMetadata(fileId: string) {
    return this.http
      .get<FileMetadata>(
        `${this.apiServer}api/Files/getFileDetails/${fileId}`
      )
      .pipe(retry(3));
  }
}
